import '../plugins/scroller.js';

var scroll = {};

var header = {
	exists: false,
	changed: false,
	isSticky: true,
	isSmall: false,
	DOM: {
		$this: null
	}
};

var footerCourse = {
	exists: false,
	changed: false,
	isSticky: false,
	DOM: {
		$this: null,
		$btn: null,
	}
};

// Header:
header.items = function () {
	if ($('.js-header').length > 0) {
		header.exists = true;
		header.DOM.$this = $('.js-header');
	}
}

header.calculation = function (pos) {
	if (header.exists) {
		//console.log(pos);
		if (pos.current.top > 260 && pos.direction == 'down') {
			header.changed = true;
			header.isSticky = false;
			header.isSmall = false;
		} else if (pos.direction == 'up') {
			header.changed = true;
			header.isSticky = true;
			header.isSmall = true;
			if (pos.current.top < 50) {
				header.isSmall = false;
			}
		}
	}
}

header.animation = function (pos) {
	if (header.changed) {
		if (header.isSticky) {
			header.DOM.$this.removeClass('is-not-sticky');
		} else {
			header.DOM.$this.addClass('is-not-sticky');
		}
		if (header.isSmall) {
			header.DOM.$this.addClass('is-small');
		} else {
			header.DOM.$this.removeClass('is-small');
		}
	}
}

header.resize = function (pos) {

}

// Footer:
footerCourse.items = function () {
	if ($('.js-footer-course').length > 0) {
		footerCourse.exists = true;
		footerCourse.DOM.$this = $('.js-footer-course');
		footerCourse.DOM.$btn = $('.cta-course .btn:visible');
	}
}

footerCourse.calculation = function (pos) {
	if (footerCourse.exists) {
		const btn = footerCourse.DOM.$btn,
			btnPos = btn.offset().top,
			headerHeight = $('.js-header').height();
		const start = btnPos - headerHeight;
		if (start <= pos.current.top) {
			footerCourse.changed = true;
			footerCourse.isSticky = true;
		} else {
			footerCourse.changed = true;
			footerCourse.isSticky = false;
		}
	}
}

footerCourse.animation = function (pos) {
	if (footerCourse.changed) {
		if (footerCourse.isSticky) {
			footerCourse.DOM.$this.addClass('is-sticky');
		} else {
			footerCourse.DOM.$this.removeClass('is-sticky');
		}
	}
}

footerCourse.resize = function (pos) {
	// nice to have: would be to recalculate heights & positions on resize
}

scroll.init = function () {
	$(window).scroller({
		items: function () {
			header.items();
			footerCourse.items();
		},
		calculation: function (pos) {
			header.calculation(pos);
			footerCourse.calculation(pos);
		},
		animation: function (pos) {
			header.animation(pos);
			footerCourse.animation(pos);
		},
		resize: function () {
			header.resize();
			footerCourse.resize();
		},
	});

}

export { scroll };
